/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createToggleOfFeaturesAndRolesFromDiscriminatorValue, type ToggleOfFeaturesAndRoles } from '../../../models/index.js';
// @ts-ignore
import { type WithKeyItemRequestBuilder, WithKeyItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/Features
 */
export interface FeaturesRequestBuilder extends BaseRequestBuilder<FeaturesRequestBuilder> {
    /**
     * Gets an item from the Kiota.TypeScript.Api.api.vWithVersion.Features.item collection
     * @param key The feature key to retrieve.
     * @returns {WithKeyItemRequestBuilder}
     */
     byKey(key: string) : WithKeyItemRequestBuilder;
    /**
     * Gets all feature toggles for the current user, ordered by feature name.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ToggleOfFeaturesAndRoles[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ToggleOfFeaturesAndRoles[] | undefined>;
    /**
     * Gets all feature toggles for the current user, ordered by feature name.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FeaturesRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/Features";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FeaturesRequestBuilderNavigationMetadata: Record<Exclude<keyof FeaturesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byKey: {
        requestsMetadata: WithKeyItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["key"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FeaturesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FeaturesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createToggleOfFeaturesAndRolesFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
